const Photographer = `
  id
  description
`;

export default Photographer;
